module.exports = __webpack_public_path__ + "static/media/diamond.f49a0b8e.png";